<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <mat-horizontal-stepper [linear]="true" class="pt-16" labelPosition="bottom" #stepper (selectionChange)="onStepChange($event, stepper)">
        <mat-step [completed]="selectedTeam">
            <ng-template matStepLabel>{{ 'USER.DIALOG.ASSIGN_TO_TEAM.LABEL.SELECT_TEAM' | translate }}</ng-template>

            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree" *ngIf="listTree?.length; else noTeams">
                <!-- This is the tree node template for leaf nodes -->
                <!-- There is inline padding applied to this node using styles.
          This padding value depends on the mat-icon-button width. -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p p-16 pr-24">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <button class="mr-8" mat-icon-button>
                                <mat-icon class="circle">circle</mat-icon>
                            </button>
                            <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                <mat-icon svgIcon="team"></mat-icon>
                            </div>
                            <h3>{{ node.name }}</h3>
                        </div>

                        <app-flat-button
                            [label]="'GENERAL.BUTTON.SELECT'"
                            (onClick)="onSelect(node)"
                            [disabled]="selectedTeam && selectedTeam.id !== node.id"
                            *ngIf="!node.isSelected; else unselect"
                        ></app-flat-button>

                        <ng-template #unselect>
                            <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(node)"></app-white-button>
                        </ng-template>
                    </div>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-tree-node p-16 pr-24">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <button mat-icon-button class="mr-8" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                                <mat-icon class="mat-icon-rtl-mirror">
                                    {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                                </mat-icon>
                            </button>
                            <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                <mat-icon svgIcon="team"></mat-icon>
                            </div>
                            <h3>{{ node.name }}</h3>
                        </div>

                        <app-flat-button
                            [label]="'GENERAL.BUTTON.SELECT'"
                            (onClick)="onSelect(node)"
                            [disabled]="selectedTeam && selectedTeam.id !== node.id"
                            *ngIf="!node.isSelected; else unselect"
                        ></app-flat-button>

                        <ng-template #unselect>
                            <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(node)"></app-white-button>
                        </ng-template>
                    </div>
                    <!-- There is inline padding applied to this div using styles.
                This padding value depends on the mat-icon-button width.  -->
                    <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                </mat-nested-tree-node>
            </mat-tree>

            <ng-template #noTeams>
                <div fxLayout="column" fxLayoutAlign="center center" class="p-32">
                    <mat-icon class="participant-view-illustration" svgIcon="team_illustration"></mat-icon>
                    <h3 class="mt-8 mb-16">
                        {{ 'TEAMS.DIALOG.MOVE_TO.NO_TEAMS' | translate }}
                    </h3>
                </div>
            </ng-template>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{ 'USER.DIALOG.ASSIGN_TO_TEAM.LABEL.SELECT_TEAM_REVIEW' | translate }}</ng-template>

            <div class="mb-24" fxLayoutAlign="flex-end center">
                <app-white-button
                    [icon]="'add'"
                    [label]="'PERFORMANCE_REVIEW.PERFORMANCE_REVIEWS.CREATE_NEW_PERFORMANCE_REVIEW'"
                    (onClick)="createPerformanceTeamReview()"
                ></app-white-button>
            </div>

            <div class="border border-gray-300" *ngIf="(filteredPerformanceTeamReviews$ | async)?.length; else noData">
                <app-performance-team-reviews-list
                    [performanceTeamReviewsStateTotalCount$]="performanceTeamReviewsStateTotalCount$"
                    [performanceTeamReviewsStateSearchTerm$]="performanceTeamReviewsStateSearchTerm$"
                    [filteredPerformanceTeamReviews$]="filteredPerformanceTeamReviews$"
                    [isFetchingPerformanceTeamReviewsList$]="isFetchingPerformanceTeamReviewsList$"
                    [loadPerformanceTeamReviews$]="loadPerformanceTeamReviews$"
                    [teamId]="selectedTeam?.id"
                    [displayedColumns]="performanceReviewDisplayedColumns"
                    [performanceProfilePersonalReview]="performanceProfilePersonalReview"
                    [isViewOnly]="isViewOnly"
                    (selectedReview)="onSelectedPerformanceTeamReview($event)"
                ></app-performance-team-reviews-list>
            </div>

            <ng-template #noData>
                <div class="py-212 bg-white" fxLayout="column" fxLayoutAlign="center center">
                    <mat-icon class="participant-view-illustration" svgIcon="template_illustration"></mat-icon>
                    <h2 class="mt-8 mb-0">{{ 'PERFORMANCE_REVIEW.PERFORMANCE_REVIEWS.NO_PERFORMANCE_REVIEWS_YET' | translate }}</h2>
                </div>
            </ng-template>
        </mat-step>
    </mat-horizontal-stepper>
</div>
<div class="pt-24 action-buttons" fxLayoutAlign="space-between center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <div fxLayoutAlign="flex-end center">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.BACK'" (onClick)="goBack(stepper)" *ngIf="isLastStep"></app-white-button>
        <app-flat-button
            [label]="'GENERAL.BUTTON.NEXT'"
            class="mr-8"
            [disabled]="!selectedTeam || isLastStep"
            [isLoading]="isNextBtnLoading"
            (onClick)="goForward(stepper)"
            *ngIf="!isLastStep"
        ></app-flat-button>
        <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" [disabled]="!selectedPerformanceReview" (onClick)="onSave()" *ngIf="isLastStep"></app-flat-button>
    </div>
</div>
